import { Stack, Typography } from '@mui/material';
import { FloodImpact } from 'features/riverGauges/riverGauges.types';
import { Trans, useTranslation } from 'react-i18next';

type FloodImpactsProps = {
  floodImpacts: FloodImpact[];
  levelUnits: string;
};

export const FloodImpacts = (props: FloodImpactsProps): JSX.Element => {
  const { floodImpacts, levelUnits } = props;
  const { t } = useTranslation();

  return (
    <Stack spacing={2} aria-labelledby="flood-impacts-title">
      <Typography variant="h3" id="flood-impacts-title">
        {t('riverGauges.floodImpacts')}
      </Typography>

      {[...floodImpacts]
        .sort((a, b) => b.level - a.level)
        .map(({ level, statement }) => (
          <Typography key={level}>
            <Trans
              i18nKey="riverGauges.floodImpactItem"
              values={{ level, unit: levelUnits, statement }}
            >
              <b>47 ft:</b>
              In Guerneville businesses on the north side of Main Street flood.
              Travel most areas impossible.
            </Trans>
          </Typography>
        ))}
    </Stack>
  );
};
